import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";

import styles from "./Stars.module.css";

const renderStar = (isFull) => {
  const icon = isFull ? faStar : regularStar;
  return <FontAwesomeIcon icon={icon} size="xs" />;
};

const Star = ({ isFull }) => (
  <span className={styles.star}>
    {renderStar(isFull)}
  </span>
);

export default Star;
